import request from '@/utils/request'


// 查询售后地址列表
export function listAddress(query) {
  return request({
    url: '/refund/address/list',
    method: 'get',
    params: query
  })
}

// 查询售后地址分页
export function pageAddress(query) {
  return request({
    url: '/refund/address/page',
    method: 'get',
    params: query
  })
}

// 查询售后地址详细
export function getAddress(data) {
  return request({
    url: '/refund/address/detail',
    method: 'get',
    params: data
  })
}

// 新增售后地址
export function addAddress(data) {
  return request({
    url: '/refund/address/add',
    method: 'post',
    data: data
  })
}

// 修改售后地址
export function updateAddress(data) {
  return request({
    url: '/refund/address/edit',
    method: 'post',
    data: data
  })
}

// 删除售后地址
export function delAddress(data) {
  return request({
    url: '/refund/address/delete',
    method: 'post',
    data: data
  })
}
